import { makeVar } from '@apollo/client';

const upcomingHolidayDatesVar = makeVar(new Set());

export default upcomingHolidayDatesVar;
